module.exports = __webpack_public_path__ + "img/twitter.7ad97f3b.svg";